'use strict';

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.set");

var _toConsumableArray = require("C:/Users/Caramel/Documents/Capstone/Hylian/node_modules/@babel/runtime/helpers/toConsumableArray");

module.exports = function () {
  var _ref;

  return _toConsumableArray(new Set((_ref = []).concat.apply(_ref, arguments)));
};